import { useCompanyInfo } from "@/context/CompanyInfoContext";

/**
 * Logo — italic condensed wordmark in navy + transportation-blue.
 * If admin uploads a custom logo_url, render that instead.
 */
export function Logo({ size = "md", overrideUrl }) {
  const { info } = useCompanyInfo();
  const rawUrl = overrideUrl ?? info?.logo_url ?? "";
  const logoUrl = rawUrl && rawUrl.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${rawUrl}`
    : rawUrl;

  const heightMap = { sm: "h-9", md: "h-11 md:h-12", lg: "h-16 md:h-20" };

  if (logoUrl) {
    return (
      <div className="inline-flex items-center select-none" data-testid="lt-logo-image">
        <img
          src={logoUrl}
          alt={info?.name || "Lucas Trans Inc."}
          className={`${heightMap[size] || heightMap.md} w-auto object-contain block`}
          style={{ maxWidth: size === "lg" ? "320px" : size === "sm" ? "170px" : "230px" }}
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      </div>
    );
  }

  const sz = {
    sm: { primary: "text-xl md:text-2xl", secondary: "text-[10px]" },
    md: { primary: "text-2xl md:text-3xl", secondary: "text-[10px] md:text-[11px]" },
    lg: { primary: "text-5xl md:text-6xl", secondary: "text-xs md:text-sm" },
  }[size] || { primary: "text-2xl md:text-3xl", secondary: "text-[11px]" };

  return (
    <div className="inline-flex flex-col items-start select-none leading-none" data-testid="lt-logo">
      <div className={`font-italic-display uppercase leading-[0.85] ${sz.primary}`}>
        <span className="text-[color:var(--lt-navy)]">LUCAS </span>
        <span className="text-[color:var(--lt-accent)]">TRANS </span>
        <span className="text-[color:var(--lt-navy)]">INC</span>
      </div>
      <div className={`font-head font-semibold uppercase tracking-[0.28em] mt-1.5 text-[color:var(--lt-navy)]/70 ${sz.secondary}`}>
        Refrigerated Freight Solutions
      </div>
    </div>
  );
}
